import React from "react";
import MonthlyTimeTable from "../MonthlyTimeTable";

const MaySehriIftaar = ({districtDetails}) => {
  return <MonthlyTimeTable month={5} title="May Sehri Iftar" columnKey="3Columns" districtDetails={districtDetails} />;
};

export default MaySehriIftaar;
